/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */

import { Bouncer } from "/Assets/libs/bouncer-es6.js";
import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";

document.addEventListener("DOMContentLoaded", () => {
    if (document.querySelector(".powermax-payback-calculator")) {
        const powermaxPaybackCalculator = new PowermaxPaybackCalculator();
        powermaxPaybackCalculator.init();
    }
});

class PowermaxPaybackCalculator {
    init() {
        this.element = document.querySelector(".powermax-payback-calculator");
        if (!this.element) return;

        this.form = this.element.querySelector("form");
        this.formCntnr = this.element.querySelector(".form-cntnr");
        this.submitButton = this.element.querySelector(".calculate");
        this.results = this.element.querySelector(".calculator-results");
        this.overlay = this.element.querySelector(".overlay");
        this.recalculate = this.element.querySelector(".recalculate");
        this.print = this.element.querySelector(".print-results");

        const select = this.form.querySelector("select");
        new tomSelect(select, {});

        this.setupFormValidation();
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener("bouncerFormValid", (event) => {
            if (event.target.classList.contains("powermax-payback-calculator-form")) {
                this.handleSubmit();
            }
        }, false);

        this.element.addEventListener("click", (event) => {
            if (event.target.classList.contains("recalculate")) {
                event.preventDefault();
                this.hideResults();
            } else if (event.target.classList.contains("print-results")) {
                event.preventDefault();
                window.print();
            }
        });
    }

    async handleSubmit() {
        const url = this.form.getAttribute("action");
        const method = this.form.getAttribute("method");
        const bodyFormData = new FormData(this.form);
        const errorMessageElement = this.element.querySelector(".error-message");

        try {
            const response = await fetch(url, {
                method: method,
                body: bodyFormData
            });

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            const data = await response.text();
            this.showResults(data);
            errorMessageElement.style.display = "none"; // Hide error message on success
        } catch (error) {
            errorMessageElement.textContent = window.jsl10n.JsResources.Translations.Common.ErrorHasOccurred;
            errorMessageElement.style.display = "block"; // Show error message
        }
    }

    showResults(data) {
        const isMobile = ResponsiveBootstrapToolkit.is("xs");
        this.results.innerHTML = data;

        if (isMobile) {
            this.formCntnr.classList.add("hide");
        } else {
            this.element.classList.add("show-overlay");
        }
    }

    hideResults() {
        const isMobile = ResponsiveBootstrapToolkit.is("xs");
        this.results.innerHTML = "";

        if (isMobile) {
            this.formCntnr.classList.remove("hide");
        } else {
            this.element.classList.remove("show-overlay");
        }
    }

    setupFormValidation() {
        const bouncer = new Bouncer("[data-validate]", {
            disableSubmit: true,
            messages: {
                missingValue: {
                    checkbox: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    radio: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    select: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    "select-multiple": window.jsl10n.JsResources.Translations.Common.ThisFieldRequired,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                },
                patternMismatch: {
                    email: window.jsl10n.JsResources.Translations.Common.EnterValidEmailAddress,
                    number: window.jsl10n.JsResources.Translations.Common.EnterValidNumber,
                    default: window.jsl10n.JsResources.Translations.Common.ThisFieldRequired
                }
            }
        });
        this.bouncer = bouncer;
    }
}